import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useAppId } from '../../context/AppIdContext';
import Header from '../../component/header';
import '../../style/dashboard.css';

const BASE_URL = process.env.REACT_APP_BASE_URL;

const BoothCaptain = () => {
    const navigate = useNavigate();
    const { appId, language, vidhanSabhaName, vidhanSabhaNo, userId, userType, userName } = useAppId();

    const lang = language || 'en';

    // --- ROLE VERIFICATION LOGIC ---
    const roleCode = userType?.toUpperCase() || '';
    const isWarroomPramukh = roleCode === 'WP' || roleCode === 'WARROOM_PRAMUKH';

    // --- Translation Dictionary ---
    const t = {
        en: {
            pageTitle: "Booth Captains",
            totalBooths: "Total Booths",
            assignedBooths: "Assigned Booths",
            boothNo: "Booth No.",
            voters: "Voters",
            boothCaptain: "Booth Captain",
            notAssigned: "Not Assigned",
            active: "Active",
            notActive: "Not Active",
            noData: "No Booths found.",
            loading: "Loading data...",
            searchPlaceholder: "Search by booth no or name...",
            createCaptain: "Create Captain",
            captainNotAssigned: "Captain not assigned for this booth",
            cancelBtn: "Cancel",
            submitBtn: "Create Captain",
            addingBtn: "Creating...",
            addModalTitle: "Create Booth Captain",
            editModalTitle: "Edit Captain",
            nameLabel: "Full Name",
            mobileLabel: "Mobile Number",
            fillAllFields: "Please fill all details",
            validMobile: "Please enter a valid 10-digit mobile number",
            mobileRequired: "Mobile number is required",
            mobileLength: "Mobile number must be 10 digits",
            mobileNumeric: "Mobile number must contain only digits",
            mobileInvalid: "Please enter a valid Indian mobile number (starts with 6,7,8,9)",
            addSuccess: "Booth Captain Created Successfully",
            addError: "Error creating captain",
            updateBtn: "Update",
            updatingBtn: "Updating...",
            deleteConfirm: "Are you sure you want to delete this captain?",
            deleteSuccess: "Captain deleted successfully!",
            deleteFailed: "Failed to delete captain.",
            deleteError: "Error deleting captain.",
            userIdMissing: "Error: User ID is missing.",
            call: "Call",
            message: "Message",
            profile: "Profile",
            sendWhatsapp: "Send Responsibility in Whatsapp",
            sendSMS: "Send Responsibility in SMS"
        },
        hi: {
            pageTitle: "बूथ कैप्टन",
            totalBooths: "कुल बूथ",
            assignedBooths: "आवंटित बूथ",
            boothNo: "बूथ नं.",
            voters: "मतदाता",
            boothCaptain: "बूथ कैप्टन",
            notAssigned: "आवंटित नहीं",
            active: "सक्रिय",
            notActive: "सक्रिय नहीं",
            noData: "कोई बूथ नहीं मिला।",
            loading: "डेटा लोड हो रहा है...",
            searchPlaceholder: "बूथ नंबर या नाम से खोजें...",
            createCaptain: "कैप्टन बनाएं",
            captainNotAssigned: "इस बूथ के लिए कैप्टन नियुक्त नहीं है",
            cancelBtn: "रद्द करें",
            submitBtn: "कैप्टन बनाएं",
            addingBtn: "बनाया जा रहा है...",
            addModalTitle: "बूथ कैप्टन बनाएं",
            editModalTitle: "कैप्टन संपादित करें",
            nameLabel: "पूरा नाम",
            mobileLabel: "मोबाइल नंबर",
            fillAllFields: "कृपया सभी विवरण भरें",
            validMobile: "कृपया 10 अंकों का मोबाइल नंबर दर्ज करें।",
            mobileRequired: "मोबाइल नंबर आवश्यक है",
            mobileLength: "मोबाइल नंबर 10 अंकों का होना चाहिए",
            mobileNumeric: "मोबाइल नंबर में केवल अंक होने चाहिए",
            mobileInvalid: "कृपया एक वैध भारतीय मोबाइल नंबर दर्ज करें (6,7,8,9 से शुरू)",
            addSuccess: "बूथ कैप्टन सफलतापूर्वक बनाया गया",
            addError: "कैप्टन बनाने में त्रुटि",
            updateBtn: "अपडेट करें",
            updatingBtn: "अपडेट कर रहा है...",
            deleteConfirm: "क्या आप वाकई इस कैप्टन को हटाना चाहते हैं?",
            deleteSuccess: "कैप्टन सफलतापूर्वक हटा दिया गया!",
            deleteFailed: "कैप्टन हटाने में विफल।",
            deleteError: "कैप्टन हटाने में त्रुटि।",
            userIdMissing: "त्रुटि: उपयोगकर्ता आईडी गायब है।",
            call: "कॉल",
            message: "संदेश",
            profile: "प्रोफाइल",
            sendWhatsapp: "व्हाट्सएप में जिम्मेदारी भेजें",
            sendSMS: "एसएमएस में जिम्मेदारी भेजें"
        },
        gu: {
            pageTitle: "બૂથ કેપ્ટન",
            totalBooths: "કુલ બૂથ",
            assignedBooths: "ફાળવેલ બૂથ",
            boothNo: "બૂથ નં.",
            voters: "મતદાર",
            boothCaptain: "બૂથ કેપ્ટન",
            notAssigned: "સોંપેલ નથી",
            active: "Active",
            notActive: "Not Active",
            noData: "કોઈ બૂથ મળ્યું નથી.",
            loading: "માહિતી લોડ થઈ રહી છે...",
            searchPlaceholder: "બૂથ નંબર અથવા નામ દ્વારા શોધો...",
            createCaptain: "કેપ્ટન બનાવો",
            captainNotAssigned: "આ બૂથ માટે કેપ્ટન સોંપેલ નથી",
            cancelBtn: "રદ કરો",
            submitBtn: "કેપ્ટન બનાવો",
            addingBtn: "બનાવી રહ્યા છે...",
            addModalTitle: "બૂથ કેપ્ટન બનાવો",
            editModalTitle: "કેપ્ટન સંપાદિત કરો",
            nameLabel: "પૂરું નામ",
            mobileLabel: "મોબાઇલ નંબર",
            fillAllFields: "કૃપા કરીને બધી વિગતો ભરો",
            validMobile: "કૃપા કરીને 10 અંકનો મોબાઇલ નંબર દાખલ કરો.",
            mobileRequired: "મોબાઇલ નંબર જરૂરી છે",
            mobileLength: "મોબાઇલ નંબર 10 અંકનો હોવો જોઈએ",
            mobileNumeric: "મોબાઇલ નંબરમાં માત્ર અંકો હોવા જોઈએ",
            mobileInvalid: "કૃપા કરીને માન્ય ભારતીય મોબાઇલ નંબર દાખલ કરો (6,7,8,9 થી શરૂ)",
            addSuccess: "બૂથ કેપ્ટન સફળતાપૂર્વક બનાવ્યો",
            addError: "કેપ્ટન બનાવવામાં ભૂલ",
            updateBtn: "અપડેટ કરો",
            updatingBtn: "અપડેટ કરી રહ્યા છીએ...",
            deleteConfirm: "શું તમે ખરેખર આ કેપ્ટનને કાઢી નાખવા માંગો છો?",
            deleteSuccess: "કેપ્ટન સફળતાપૂર્વક કાઢી નાખવામાં આવ્યો!",
            deleteFailed: "કેપ્ટન કાઢી નાખવામાં નિષ્ફળ.",
            deleteError: "કેપ્ટન કાઢી નાખવામાં ભૂલ.",
            userIdMissing: "ભૂલ: વપરાશકર્તા ID ગુમ થયેલ છે.",
            call: "કૉલ",
            message: "સંદેશ",
            profile: "પ્રોફાઇલ",
            sendWhatsapp: "વોટ્સએપમાં જવાબદારી મોકલો",
            sendSMS: "એસએમએસમાં જવાબદારી મોકલો"
        }
    };

    const txt = t[lang] || t.en;

    const [booths, setBooths] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [selectedBooth, setSelectedBooth] = useState(null);
    const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);

    // --- Edit Modal State ---
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [editFormData, setEditFormData] = useState({
        user_id: '',
        name: '',
        mobile_no: '',
        user_type: ''
    });
    const [editMobileError, setEditMobileError] = useState("");

    // --- Create Captain Modal State ---
    const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
    const [createBooth, setCreateBooth] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [formData, setFormData] = useState({ name: '', mobile_no: '' });
    const [mobileError, setMobileError] = useState("");

    // Generate WhatsApp message
    const generateWhatsAppMessage = (captainName) => {
        const loginUserName = userName || 'Admin';
        return `નમસ્તે ${captainName}, ${loginUserName} એ તમને બૂથ કેપ્ટનની જવાબદારી સોંપેલી છે.`;
    };

    // Generate SMS message
    const generateSMSMessage = (captainName) => {
        const loginUserName = userName || 'Admin';
        return `નમસ્તે ${captainName}, ${loginUserName} એ તમને બૂથ કેપ્ટનની જવાબદારી સોંપેલી છે.`;
    };

    useEffect(() => {
        if (!appId) {
            navigate('/login');
            return;
        }

        const fetchBoothCaptains = async () => {
            setLoading(true);
            try {
                const apiEndpoint = isWarroomPramukh
                    ? `${BASE_URL}/api/dis_booth_captain_by_warroom_pramukh`
                    : `${BASE_URL}/api/dis_booth_captain`;

                const response = await axios.post(apiEndpoint, {
                    app_id: appId,
                    user_id: userId
                });

                if (response.data.success && response.data.data && response.data.data.result) {
                    setBooths(response.data.data.result);
                } else {
                    setBooths([]);
                }
            } catch (error) {
                console.error("Error fetching booth captains:", error);
                setBooths([]);
            } finally {
                setLoading(false);
            }
        };

        fetchBoothCaptains();
    }, [appId, navigate, isWarroomPramukh, userId]);

    // Calculate assigned booths count
    const assignedBoothsCount = booths.filter(booth => booth.name !== null && booth.name !== "").length;
    const totalBoothsCount = booths.length;

    // Filter booths based on search term
    const filteredBooths = booths.filter(booth => {
        if (!searchTerm) return true;
        const lowerSearch = searchTerm.toLowerCase();
        return (
            (booth.name && booth.name.toLowerCase().includes(lowerSearch)) ||
            (booth.booth_no && booth.booth_no.toString().includes(lowerSearch))
        );
    });

    // Open detail modal - Only if captain is assigned
    const openDetailModal = (booth) => {
        const isAssigned = booth.name !== null && booth.name !== "";
        if (!isAssigned) {
            alert(txt.captainNotAssigned);
            return;
        }
        setSelectedBooth(booth);
        setIsDetailModalOpen(true);
    };

    // Close detail modal
    const closeDetailModal = () => {
        setIsDetailModalOpen(false);
        setSelectedBooth(null);
    };

    // Open create captain modal
    const openCreateModal = (booth, e) => {
        e.stopPropagation();
        setCreateBooth(booth);
        setFormData({ name: '', mobile_no: '' });
        setMobileError("");
        setIsCreateModalOpen(true);
    };

    // Close create captain modal
    const closeCreateModal = () => {
        setIsCreateModalOpen(false);
        setCreateBooth(null);
        setFormData({ name: '', mobile_no: '' });
        setMobileError("");
    };

    // --- Edit Handlers ---
    const handleEditClick = (booth) => {
        if (booth) {
            setEditFormData({
                user_id: booth.user_id || booth.id,
                name: booth.name,
                mobile_no: booth.mobile_no,
                user_type: 'BC'
            });
            setEditMobileError("");
            setSelectedBooth(null);
            setIsEditModalOpen(true);
        }
    };

    const handleEditInputChange = (e) => {
        const { name, value } = e.target;

        if (name === 'mobile_no') {
            const numericValue = value.replace(/[^0-9]/g, '');
            const limitedValue = numericValue.slice(0, 10);
            setEditFormData(prev => ({ ...prev, [name]: limitedValue }));

            if (editMobileError) setEditMobileError("");

            if (limitedValue.length === 10) {
                const validation = validateMobileNumber(limitedValue);
                if (!validation.isValid) {
                    setEditMobileError(validation.message);
                } else {
                    setEditMobileError("");
                }
            } else if (limitedValue.length > 0 && limitedValue.length < 10) {
                setEditMobileError(txt.mobileLength);
            }
        } else {
            setEditFormData(prev => ({ ...prev, [name]: value }));
        }
    };

    const handleUpdateSubmit = async (e) => {
        e.preventDefault();

        if (!editFormData.name || !editFormData.mobile_no) {
            alert(txt.fillAllFields);
            return;
        }

        const validation = validateMobileNumber(editFormData.mobile_no);
        if (!validation.isValid) {
            alert(validation.message);
            setEditMobileError(validation.message);
            return;
        }

        setIsEditing(true);

        const payload = {
            user_id: editFormData.user_id,
            app_id: appId,
            name: editFormData.name,
            mobile_no: editFormData.mobile_no,
            user_type: editFormData.user_type,
            booth_no: selectedBooth?.booth_no || '',
            booth_list: "",
            create_by: userId || "Admin"
        };

        try {
            const response = await axios.post(`${BASE_URL}/api/update_user`, payload);
            if (response.data.success && response.data.data && response.data.data.Success == "1") {
                alert("Updated successfully!");
                setIsEditModalOpen(false);
                setEditMobileError("");
                // Refresh the list
                const fetchApiEndpoint = isWarroomPramukh
                    ? `${BASE_URL}/api/dis_booth_captain_by_warroom_pramukh`
                    : `${BASE_URL}/api/dis_booth_captain`;
                const fetchResponse = await axios.post(fetchApiEndpoint, {
                    app_id: appId,
                    user_id: userId
                });
                if (fetchResponse.data.success && fetchResponse.data.data && fetchResponse.data.data.result) {
                    setBooths(fetchResponse.data.data.result);
                }
            } else {
                alert(response.data.data?.Message || "Failed to update.");
            }
        } catch (error) {
            console.error("Axios Error:", error);
            alert(error.response?.data?.error || "Error updating.");
        } finally {
            setIsEditing(false);
        }
    };

    // --- Delete Handler ---
    const handleDeleteCaptain = async (id) => {
        if (!id) {
            alert(txt.userIdMissing);
            return;
        }

        if (window.confirm(txt.deleteConfirm)) {
            try {
                const response = await axios.post(`${BASE_URL}/api/dlt_user`, {
                    app_id: appId,
                    user_id: id,
                    delete_by: userId || "Admin"
                });

                if (response.data.success || response.data.Success == "1" || (response.data.data && response.data.data.Success == "1")) {
                    alert(txt.deleteSuccess);
                    setSelectedBooth(null);
                    // Refresh the list
                    const fetchApiEndpoint = isWarroomPramukh
                        ? `${BASE_URL}/api/dis_booth_captain_by_warroom_pramukh`
                        : `${BASE_URL}/api/dis_booth_captain`;
                    const fetchResponse = await axios.post(fetchApiEndpoint, {
                        app_id: appId,
                        user_id: userId
                    });
                    if (fetchResponse.data.success && fetchResponse.data.data && fetchResponse.data.data.result) {
                        setBooths(fetchResponse.data.data.result);
                    }
                } else {
                    alert(response.data.message || response.data.Message || response.data.data?.Message || txt.deleteFailed);
                }
            } catch (error) {
                console.error("Delete Error:", error);
                alert(txt.deleteError);
            }
        }
    };

    // Mobile number validation function
    const validateMobileNumber = (number) => {
        if (!number) {
            return { isValid: false, message: txt.mobileRequired };
        }
        if (!/^\d{10}$/.test(number)) {
            return { isValid: false, message: txt.mobileLength };
        }
        if (!/^\d+$/.test(number)) {
            return { isValid: false, message: txt.mobileNumeric };
        }
        const firstDigit = number.charAt(0);
        if (!['6', '7', '8', '9'].includes(firstDigit)) {
            return { isValid: false, message: txt.mobileInvalid };
        }
        return { isValid: true, message: "" };
    };

    const handleMobileChange = (e) => {
        const value = e.target.value;
        const numericValue = value.replace(/[^0-9]/g, '');
        const limitedValue = numericValue.slice(0, 10);

        setFormData(prev => ({ ...prev, mobile_no: limitedValue }));
        if (mobileError) setMobileError("");
        if (limitedValue.length === 10) {
            const validation = validateMobileNumber(limitedValue);
            if (!validation.isValid) {
                setMobileError(validation.message);
            } else {
                setMobileError("");
            }
        } else if (limitedValue.length > 0 && limitedValue.length < 10) {
            setMobileError(txt.mobileLength);
        }
    };

    const handleCreateCaptain = async (e) => {
        e.preventDefault();

        const validation = validateMobileNumber(formData.mobile_no);
        if (!formData.name || !formData.mobile_no) {
            alert(txt.fillAllFields);
            return;
        }
        if (!validation.isValid) {
            alert(validation.message);
            setMobileError(validation.message);
            return;
        }

        setIsSubmitting(true);
        try {
            const payload = {
                app_id: appId,
                name: formData.name,
                mobile_no: formData.mobile_no,
                booth_no: createBooth.booth_no,
                user_type: "BC",
                create_by: userId || "Admin"
            };

            const response = await axios.post(`${BASE_URL}/api/insert_user`, payload);
            if (response.data.success && response.data.data && response.data.data.Success == "1") {
                alert(txt.addSuccess);
                closeCreateModal();
                // Refresh the list
                const fetchApiEndpoint = isWarroomPramukh
                    ? `${BASE_URL}/api/dis_booth_captain_by_warroom_pramukh`
                    : `${BASE_URL}/api/dis_booth_captain`;
                const fetchResponse = await axios.post(fetchApiEndpoint, {
                    app_id: appId,
                    user_id: userId
                });
                if (fetchResponse.data.success && fetchResponse.data.data && fetchResponse.data.data.result) {
                    setBooths(fetchResponse.data.data.result);
                }
            } else {
                alert(response.data.data?.Message || "Mobile number already exists or failed to create captain.");
            }
        } catch (error) {
            console.error("Axios Error:", error);
            alert(txt.addError);
        } finally {
            setIsSubmitting(false);
        }
    };

    // Handle card click - Only navigate if captain is assigned
    const handleCardClick = (booth) => {
        const isAssigned = booth.name !== null && booth.name !== "";
        if (isAssigned) {
            navigate('/dis_booth_captain_cadre_with_voter', { state: { boothId: booth.booth_no } });
        }
    };

    return (
        <div className="booth-captain-container dashboard-page">
            {/* Header */}
            <div className="header-wrapper shadow-sm">
                <Header title={txt.pageTitle} />
            </div>

            <div className="content-container container-fluid p-3 p-md-4 mx-auto">

                {/* --- Search Bar and Stats Row --- */}
                <div className="search-stats-row mb-4 slide-up-element" style={{ animationDelay: '0.05s' }}>
                    {/* UPDATED: Professional Filter Container from MyGroup page */}
                    <div className="filter-container-modern">
                        <div className="search-wrapper-modern">
                            <svg className="search-icon-modern" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                            </svg>
                            <input
                                className="search-input-modern"
                                type="text"
                                placeholder={txt.searchPlaceholder}
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                        </div>
                    </div>

                    {/* Stats Cards */}
                    <div className="stats-container">
                        <div className="stat-card total-card">
                            <div className="stat-icon">🏢</div>
                            <div className="stat-info">
                                <span className="stat-label">{txt.totalBooths}</span>
                                <span className="stat-value">{totalBoothsCount}</span>
                            </div>
                        </div>
                        <div className="stat-card assigned-card">
                            <div className="stat-icon">✅</div>
                            <div className="stat-info">
                                <span className="stat-label">{txt.assignedBooths}</span>
                                <span className="stat-value">{assignedBoothsCount}</span>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Create Captain Modal - Updated to match AdminUsers styling */}
                {isCreateModalOpen && createBooth && (
                    <div className="modal-overlay">
                        <div className="modal-content-box" style={{ maxWidth: '400px', width: '95%', padding: "0px" }}>
                            <div className="modal-header">
                                <h2>{txt.addModalTitle} - Booth {createBooth.booth_no}</h2>
                                <button className="close-btn-icon" onClick={closeCreateModal}>
                                    <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" /></svg>
                                </button>
                            </div>
                            <form onSubmit={handleCreateCaptain}>
                                <div className="modal-body-grid" style={{ display: 'flex', flexDirection: 'column', gap: '15px', padding: '10px 0' }}>
                                    <div className="form-group" style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                                        <label style={{ fontSize: '14px', fontWeight: '600', color: '#374151' }}>{txt.nameLabel}</label>
                                        <input
                                            type="text"
                                            className="form-input"
                                            style={{ padding: '10px 15px', borderRadius: '8px', border: '1px solid #d1d5db', outline: 'none' }}
                                            required
                                            value={formData.name}
                                            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                                        />
                                    </div>
                                    <div className="form-group" style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                                        <label style={{ fontSize: '14px', fontWeight: '600', color: '#374151' }}>{txt.mobileLabel}</label>
                                        <input
                                            type="text"
                                            className="form-input"
                                            style={{
                                                padding: '10px 15px',
                                                borderRadius: '8px',
                                                border: mobileError ? '1px solid #ef4444' : '1px solid #d1d5db',
                                                outline: 'none'
                                            }}
                                            required
                                            maxLength="10"
                                            value={formData.mobile_no}
                                            onChange={handleMobileChange}
                                        />
                                        {mobileError && (
                                            <div style={{ fontSize: '12px', color: '#ef4444', marginTop: '4px' }}>
                                                {mobileError}
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className="modal-footer" style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '10px' }}>
                                    <button type="button" className="btn-cancel" onClick={closeCreateModal} style={{ padding: '10px 20px', borderRadius: '8px', border: '1px solid #d1d5db', background: 'white', cursor: 'pointer' }}>
                                        {txt.cancelBtn}
                                    </button>
                                    <button type="submit" className="btn-search-main" disabled={isSubmitting} style={{ padding: '10px 20px', borderRadius: '8px', border: 'none', background: '#2563eb', color: 'white', cursor: isSubmitting ? 'not-allowed' : 'pointer' }}>
                                        {isSubmitting ? txt.addingBtn : txt.submitBtn}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                )}

                {/* Edit Captain Modal - Updated to match AdminUsers styling */}
                {isEditModalOpen && (
                    <div className="modal-overlay">
                        <div className="modal-content-box" style={{ maxWidth: '400px', width: '95%', padding: "0px" }}>
                            <div className="modal-header">
                                <h2>{txt.editModalTitle} - Booth {selectedBooth?.booth_no}</h2>
                                <button className="close-btn-icon" onClick={() => setIsEditModalOpen(false)}>
                                    <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" /></svg>
                                </button>
                            </div>
                            <form onSubmit={handleUpdateSubmit}>
                                <div className="modal-body-grid" style={{ display: 'flex', flexDirection: 'column', gap: '15px', padding: '10px 0' }}>
                                    <div className="form-group" style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                                        <label style={{ fontSize: '14px', fontWeight: '600', color: '#374151' }}>{txt.nameLabel}</label>
                                        <input
                                            type="text"
                                            name="name"
                                            value={editFormData.name}
                                            onChange={handleEditInputChange}
                                            className="form-input"
                                            style={{ padding: '10px 15px', borderRadius: '8px', border: '1px solid #d1d5db', outline: 'none' }}
                                            required
                                        />
                                    </div>
                                    <div className="form-group" style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                                        <label style={{ fontSize: '14px', fontWeight: '600', color: '#374151' }}>{txt.mobileLabel}</label>
                                        <input
                                            type="text"
                                            name="mobile_no"
                                            value={editFormData.mobile_no}
                                            onChange={handleEditInputChange}
                                            maxLength="10"
                                            className="form-input"
                                            style={{
                                                padding: '10px 15px',
                                                borderRadius: '8px',
                                                border: editMobileError ? '1px solid #ef4444' : '1px solid #d1d5db',
                                                outline: 'none'
                                            }}
                                            required
                                        />
                                        {editMobileError && (
                                            <div style={{ fontSize: '12px', color: '#ef4444', marginTop: '4px' }}>
                                                {editMobileError}
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className="modal-footer" style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '10px' }}>
                                    <button type="button" className="btn-cancel" onClick={() => setIsEditModalOpen(false)} style={{ padding: '10px 20px', borderRadius: '8px', border: '1px solid #d1d5db', background: 'white', cursor: 'pointer' }}>{txt.cancelBtn}</button>
                                    <button type="submit" className="btn-search-main" disabled={isEditing} style={{ padding: '10px 20px', borderRadius: '8px', border: 'none', background: '#2563eb', color: 'white', cursor: isEditing ? 'not-allowed' : 'pointer' }}>{isEditing ? txt.updatingBtn : txt.updateBtn}</button>
                                </div>
                            </form>
                        </div>
                    </div>
                )}

                {/* Profile Detail Modal - Same style as BoothPramukh */}
                {selectedBooth && isDetailModalOpen && (
                    <div className="modal-overlay" onClick={closeDetailModal}>
                        <div className="profile-detail-container" onClick={(e) => e.stopPropagation()}>
                            <button className="profile-close-btn" onClick={closeDetailModal}>
                                <svg width="24" height="24" fill="none" stroke="white" strokeWidth="2" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </button>
                            <div className="profile-detail-card">
                                <div className="profile-avatar-wrapper">
                                    <div className="profile-avatar-bg">
                                        <img 
                                            src={selectedBooth.photo_path ? selectedBooth.photo_path : `https://ui-avatars.com/api/?name=${encodeURIComponent(selectedBooth.name || 'Captain')}&background=e5e5e5&color=a3a3a3`} 
                                            alt={selectedBooth.name || "Captain"} 
                                        />
                                    </div>
                                </div>
                                <div className="profile-content">
                                    <h2 className="profile-name">{selectedBooth.name || txt.notAssigned}</h2>
                                    <p className="profile-mobile">{selectedBooth.mobile_no || "N/A"}</p>

                                    <div style={{ marginBottom: '16px' }}>
                                        <span style={{
                                            display: 'inline-block',
                                            padding: '4px 16px',
                                            borderRadius: '20px',
                                            fontSize: '11px',
                                            fontWeight: 'bold',
                                            backgroundColor: selectedBooth.last_login ? '#dcfce7' : '#fee2e2',
                                            color: selectedBooth.last_login ? '#166534' : '#991b1b',
                                            textTransform: 'uppercase'
                                        }}>
                                            {selectedBooth.last_login ? txt.active : txt.notActive}
                                        </span>
                                    </div>

                                    <div className="profile-big-btns">
                                        <a 
                                            href={`https://wa.me/91${selectedBooth.mobile_no}?text=${encodeURIComponent(generateWhatsAppMessage(selectedBooth.name))}`} 
                                            target="_blank" 
                                            rel="noreferrer" 
                                            className="btn-resp btn-wa"
                                            style={{ opacity: selectedBooth.name ? 1 : 0.5, pointerEvents: selectedBooth.name ? 'auto' : 'none' }}
                                        >
                                            <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                                                <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
                                            </svg>
                                            {txt.sendWhatsapp}
                                        </a>
                                        <a 
                                            href={`sms:${selectedBooth.mobile_no}?body=${encodeURIComponent(generateSMSMessage(selectedBooth.name))}`} 
                                            className="btn-resp btn-sms-big"
                                            style={{ opacity: selectedBooth.name ? 1 : 0.5, pointerEvents: selectedBooth.name ? 'auto' : 'none' }}
                                        >
                                            <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                                                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2 2z" />
                                            </svg>
                                            {txt.sendSMS}
                                        </a>
                                    </div>
                                </div>
                                <div className="profile-bottom-bar">
                                    <a href={`tel:${selectedBooth.mobile_no}`} className="btm-icon-wrapper" style={{ opacity: selectedBooth.name ? 1 : 0.5 }}>
                                        <div className="icon-transparent" style={{ color: '#0ea5e9' }}>
                                            <svg width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                                                <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" />
                                            </svg>
                                        </div>
                                    </a>
                                    <div className="divider"></div>
                                    <a 
                                        href={`https://wa.me/91${selectedBooth.mobile_no}`} 
                                        target="_blank" 
                                        rel="noreferrer" 
                                        className="btm-icon-wrapper"
                                        style={{ opacity: selectedBooth.name ? 1 : 0.5 }}
                                    >
                                        <div className="icon-transparent" style={{ color: '#22c55e' }}>
                                            <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
                                                <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
                                            </svg>
                                        </div>
                                    </a>
                                    <div className="divider"></div>
                                    <a 
                                        href={`sms:${selectedBooth.mobile_no}`} 
                                        className="btm-icon-wrapper"
                                        style={{ opacity: selectedBooth.name ? 1 : 0.5 }}
                                    >
                                        <div className="icon-transparent" style={{ color: '#3b82f6', position: 'relative' }}>
                                            <svg width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                                                <path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 10H6v-2h12v2zm0-3H6V7h12v2z" />
                                            </svg>
                                            <span style={{ position: 'absolute', fontSize: '7px', color: 'white', fontWeight: 'bold', marginTop: '-2px' }}></span>
                                        </div>
                                    </a>
                                    <div className="divider"></div>
                                    {/* Edit Button */}
                                    <button 
                                        className="btm-icon-wrapper" 
                                        onClick={() => navigate('/dis_booth_captain_cadre_with_voter', { state: { boothId: selectedBooth.booth_no } })} 
                                        style={{ background: 'none', border: 'none', padding: 0 }}
                                    >
                                        <div className="icon-transparent" style={{ color: '#f59e0b' }}>
                                            <svg width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                                                <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" />
                                            </svg>
                                        </div>
                                    </button>
                                    <div className="divider"></div>
                                    {/* Delete Button */}
                                    <button 
                                        className="btm-icon-wrapper" 
                                        onClick={() => navigate('/dis_booth_captain_cadre_with_voter', { state: { boothId: selectedBooth.booth_no } })} 
                                        style={{ background: 'none', border: 'none', padding: 0 }}
                                    >
                                        <div className="icon-transparent" style={{ color: '#ef4444' }}>
                                            <svg width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                                                <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z" />
                                            </svg>
                                        </div>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* Main Content Area */}
                {loading ? (
                    <div className="text-center p-5">
                        <div className="spinner-border text-primary" role="status" style={{ width: '3rem', height: '3rem' }}>
                            <span className="visually-hidden">Loading...</span>
                        </div>
                        <p className="mt-3 text-muted font-weight-bold">{txt.loading}</p>
                    </div>
                ) : filteredBooths.length > 0 ? (
                    <div className="row g-4 slide-up-element" style={{ animationDelay: '0.1s' }}>
                        {filteredBooths.map((booth, index) => {
                            const isAssigned = booth.name !== null && booth.name !== "";
                            const isActive = booth.last_login !== null;

                            return (
                                <div
                                    className="col-12 col-sm-6 col-lg-4 col-xl-3"
                                    key={index}
                                    onClick={() => handleCardClick(booth)}
                                    style={{ cursor: isAssigned ? 'pointer' : 'default' }}
                                >
                                    <div className="bc-card">

                                        {/* Top Header Section - Golden Gradient */}
                                        <div className="bc-card-header">
                                            <div
                                                className="bc-avatar"
                                                onClick={(e) => {
                                                    if (isAssigned) {
                                                        e.stopPropagation();
                                                        openDetailModal(booth);
                                                    }
                                                }}
                                                style={{ cursor: isAssigned ? 'pointer' : 'default' }}
                                            >
                                                {booth.photo_path ? (
                                                    <img src={booth.photo_path} alt={booth.name} />
                                                ) : (
                                                    <svg width="32" height="32" viewBox="0 0 24 24" fill="white">
                                                        <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
                                                    </svg>
                                                )}
                                            </div>
                                            <div className="bc-header-info">
                                                <h3 className="bc-booth-no">Booth {booth.booth_no}</h3>
                                                <p className="bc-voter-count">📊 {booth.total_voter} Voters</p>
                                            </div>
                                        </div>

                                        {/* Middle Details Section */}
                                        <div className="bc-card-body">
                                            <span className="bc-label">Booth Captain</span>
                                            <h4 className={`bc-name ${!isAssigned ? 'not-assigned' : ''}`}>
                                                {isAssigned ? booth.name : txt.notAssigned}
                                            </h4>

                                            {isAssigned ? (
                                                <div className={`bc-status-pill ${isActive ? 'active' : 'inactive'}`}>
                                                    {isActive ? txt.active : txt.notActive}
                                                </div>
                                            ) : (
                                                <div className="bc-status-pill unassigned">Not Assigned</div>
                                            )}
                                        </div>

                                        {/* Bottom Actions Section */}
                                        <div className="bc-card-footer">
                                            {isAssigned ? (
                                                <>
                                                    <button
                                                        className="bc-action-btn call-btn"
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            window.open(`tel:${booth.mobile_no}`);
                                                        }}
                                                    >
                                                        <svg width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                                                            <path strokeLinecap="round" strokeLinejoin="round" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                                                        </svg>
                                                        <span>{txt.call}</span>
                                                    </button>
                                                    <button
                                                        className="bc-action-btn sms-btn"
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            const mobile = booth.mobile_no.replace(/\D/g, '');
                                                            window.open(`https://wa.me/91${mobile}`, '_blank');
                                                        }}
                                                    >
                                                        <svg width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                                                            <path strokeLinecap="round" strokeLinejoin="round" d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
                                                        </svg>
                                                        <span>{txt.message}</span>
                                                    </button>
                                                    <button
                                                        className="bc-action-btn profile-btn"
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            openDetailModal(booth);
                                                        }}
                                                    >
                                                        <svg width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                                                            <path strokeLinecap="round" strokeLinejoin="round" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                                                        </svg>
                                                        <span>{txt.profile}</span>
                                                    </button>
                                                </>
                                            ) : (
                                                <button
                                                    className="bc-action-btn create-btn"
                                                    onClick={(e) => openCreateModal(booth, e)}
                                                    style={{
                                                        background: '#991b1b',
                                                        color: 'white',
                                                        width: '100%'
                                                    }}
                                                >
                                                    <svg width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                                                        <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                                                    </svg>
                                                    <span>{txt.createCaptain}</span>
                                                </button>
                                            )}
                                        </div>

                                    </div>
                                </div>
                            );
                        })}
                    </div>
                ) : (
                    <div className="empty-state-card text-center slide-up-element" style={{ animationDelay: '0.1s' }}>
                        <div className="empty-icon" style={{ fontSize: '40px', marginBottom: '16px' }}>🏢</div>
                        <h4>{searchTerm ? `No booths found matching "${searchTerm}"` : txt.noData}</h4>
                    </div>
                )}
            </div>

            <style jsx>{`
                .booth-captain-container { width: 100%; min-height: 100vh; background: #E5E7EB; font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif; padding-bottom: 60px; }
                .header-wrapper { background: white; padding: 0px 24px; position: sticky; top: 0; z-index: 40; box-shadow: 0 2px 8px rgba(0,0,0,0.05); }
                
                /* --- UPDATED: PROFESSIONAL FILTER CONTAINER FROM MYGROUP --- */
                .filter-container-modern {
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                    flex: 2;
                    min-width: 250px;
                }
                .search-wrapper-modern {
                    position: relative;
                    width: 100%;
                    max-width: 450px;
                }
                .search-icon-modern {
                    position: absolute;
                    left: 16px;
                    top: 50%;
                    transform: translateY(-50%);
                    color: #94a3b8;
                    width: 18px;
                    height: 18px;
                }
                .search-input-modern {
                    width: 100%;
                    padding: 12px 16px 12px 46px;
                    border: 1px solid #e2e8f0;
                    border-radius: 12px;
                    font-size: 14px;
                    color: #1e293b;
                    outline: none;
                    transition: all 0.2s ease;
                    box-shadow: 0 1px 2px rgba(0,0,0,0.05);
                    background: #ffffff;
                }
                .search-input-modern:focus {
                    border-color: #b8860b;
                    box-shadow: 0 0 0 3px rgba(184, 134, 11, 0.15);
                }

                /* Search and Stats Row */
                .search-stats-row {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    gap: 20px;
                    flex-wrap: wrap;
                }

                /* Stats Cards */
                .stats-container {
                    display: flex;
                    gap: 15px;
                    flex-shrink: 0;
                }
                
                .stat-card {
                    display: flex;
                    align-items: center;
                    gap: 12px;
                    background: white;
                    padding: 10px 20px;
                    border-radius: 14px;
                    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
                    border: 1px solid #e2e8f0;
                    transition: all 0.2s ease;
                }
                
                .stat-card:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 6px 14px rgba(0, 0, 0, 0.1);
                }
                
                .stat-card.total-card {
                    border-left: 4px solid #3b82f6;
                }
                
                .stat-card.assigned-card {
                    border-left: 4px solid #10b981;
                }
                
                .stat-icon {
                    font-size: 28px;
                }
                
                .stat-info {
                    display: flex;
                    flex-direction: column;
                }
                
                .stat-label {
                    font-size: 11px;
                    font-weight: 600;
                    color: #64748b;
                    text-transform: uppercase;
                    letter-spacing: 0.5px;
                }
                
                .stat-value {
                    font-size: 22px;
                    font-weight: 800;
                    color: #0f172a;
                    line-height: 1.2;
                }
                
                .stat-card.total-card .stat-value {
                    color: #3b82f6;
                }
                
                .stat-card.assigned-card .stat-value {
                    color: #10b981;
                }

                /* Modal Styles */
                .modal-overlay { position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(0, 0, 0, 0.6); display: flex; align-items: center; justify-content: center; z-index: 1000; padding: 20px; box-sizing: border-box; }
                .modal-content-box { background: white; border-radius: 12px; width: 100%; box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1); box-sizing: border-box; }
                .modal-header { display: flex; justify-content: space-between; align-items: center; border-bottom: 1px solid #e5e7eb; padding: 15px; margin-bottom: 10px; }
                .modal-header h2 { margin: 0; font-size: 1.25rem; color: #111827; }
                .close-btn-icon { background: none; border: none; cursor: pointer; color: #6b7280; }
                .close-btn-icon:hover { color: #111827; }

                /* Profile Detail Modal - Same as BoothPramukh */
                .profile-detail-container { position: relative; width: 100%; max-width: 380px; margin-top: 50px; }
                .profile-close-btn { position: absolute; top: -40px; right: -10px; background: none; border: none; cursor: pointer; padding: 5px; z-index: 10; color: white; }
                .profile-detail-card { background: white; border-radius: 20px; display: flex; flex-direction: column; overflow: visible; box-shadow: 0 15px 35px rgba(0,0,0,0.2); }
                .profile-avatar-wrapper { display: flex; justify-content: center; margin-top: -55px; }
                .profile-avatar-bg { width: 110px; height: 110px; background: white; border-radius: 50%; padding: 6px; cursor: pointer; position: relative; overflow: hidden; }
                .profile-avatar-bg img { width: 100%; height: 100%; border-radius: 50%; object-fit: cover; }
                .profile-content { padding: 15px 24px 25px 24px; text-align: center; }
                .profile-name { font-size: 22px; font-weight: 800; color: #111827; text-transform: uppercase; margin: 0; }
                .profile-mobile { font-size: 16px; color: #374151; letter-spacing: 0.5px; font-weight: 500; margin: 8px 0; }
                .profile-big-btns { display: flex; flex-direction: column; gap: 12px; }
                .btn-resp {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 10px;
                    width: 100%;
                    padding: 14px;
                    border-radius: 50px;
                    color: white;
                    font-weight: 600;
                    text-decoration: none;
                    font-size: 15px;
                    transition: transform 0.2s, box-shadow 0.2s;
                    border: none;
                    box-sizing: border-box;
                }
                .btn-resp:hover { transform: translateY(-2px); box-shadow: 0 4px 10px rgba(0,0,0,0.15); color: white; }
                .btn-wa { background-color: #4ade80; }
                .btn-sms-big { background-color: #f59e0b; }
                .profile-bottom-bar { background-color: #213555; border-radius: 0 0 20px 20px; display: flex; justify-content: space-evenly; align-items: center; padding: 12px 0; }
                .divider { width: 1px; height: 24px; background-color: rgba(255, 255, 255, 0.3); }
                .btm-icon-wrapper { background: none; border: none; padding: 0; cursor: pointer; display: flex; align-items: center; justify-content: center; transition: transform 0.2s; text-decoration: none; }
                .btm-icon-wrapper:hover { transform: scale(1.1); }
                .icon-transparent { display: flex; align-items: center; justify-content: center; }

                /* Card Styles */
                .bc-card {
                    background: #ffffff;
                    border-radius: 20px;
                    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
                    overflow: hidden;
                    display: flex;
                    flex-direction: column;
                    transition: all 0.3s ease;
                    height: 100%;
                    border: 1px solid #e2e8f0;
                }
                .bc-card:hover {
                    transform: translateY(-6px);
                    box-shadow: 0 20px 30px -12px rgba(0, 0, 0, 0.12);
                    border-color: #cbd5e1;
                }

                .bc-card-header {
                    background: linear-gradient(135deg, #b8860b 0%, #daa520 25%, #ffd700 50%, #b8860b 75%, #8b6914 100%);
                    padding: 20px;
                    display: flex;
                    align-items: center;
                    gap: 16px;
                    position: relative;
                    overflow: hidden;
                }
                
                .bc-card-header::before {
                    content: '';
                    position: absolute;
                    top: 0;
                    left: -100%;
                    width: 100%;
                    height: 100%;
                    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
                    transition: left 0.5s ease;
                }
                
                .bc-card-header:hover::before {
                    left: 100%;
                }
                
                .bc-avatar {
                    width: 60px;
                    height: 60px;
                    border-radius: 50%;
                    background: rgba(255, 255, 255, 0.2);
                    border: 3px solid rgba(255, 255, 255, 0.5);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    overflow: hidden;
                    flex-shrink: 0;
                    transition: transform 0.2s;
                }
                .bc-avatar:hover {
                    transform: scale(1.05);
                }
                .bc-avatar img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
                .bc-header-info {
                    display: flex;
                    flex-direction: column;
                    gap: 4px;
                }
                .bc-booth-no {
                    margin: 0;
                    font-size: 20px;
                    font-weight: 700;
                    color: black;
                }
                .bc-voter-count {
                    margin: 0;
                    font-size: 13px;
                    font-weight: 600;
                    color: black;
                }

                .bc-card-body {
                    padding: 24px 20px;
                    text-align: center;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    flex-grow: 1;
                    background: white;
                }
                .bc-label {
                    font-size: 11px;
                    font-weight: 700;
                    color: #94a3b8;
                    text-transform: uppercase;
                    letter-spacing: 1px;
                    margin-bottom: 8px;
                }
                .bc-name {
                    font-size: 18px;
                    font-weight: 700;
                    color: #0f172a;
                    margin: 0 0 16px 0;
                    line-height: 1.3;
                }
                .bc-name.not-assigned {
                    color: #94a3b8;
                    font-style: italic;
                }
                
                .bc-status-pill {
                    padding: 6px 20px;
                    border-radius: 30px;
                    font-size: 12px;
                    font-weight: 700;
                    display: inline-block;
                }
                .bc-status-pill.active {
                    background: linear-gradient(135deg, #dcfce7 0%, #bbf7d0 100%);
                    color: #166534;
                }
                .bc-status-pill.inactive {
                    background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);
                    color: #991b1b;
                }
                .bc-status-pill.unassigned {
                    background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
                    color: #64748b;
                }

                .bc-card-footer {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    padding: 12px 16px;
                    border-top: 1px solid #f1f5f9;
                    background: #fafcff;
                }
                .bc-action-btn {
                    background: none;
                    border: none;
                    cursor: pointer;
                    padding: 8px 12px;
                    border-radius: 12px;
                    transition: all 0.2s;
                    display: flex;
                    align-items: center;
                    gap: 6px;
                    font-size: 12px;
                    font-weight: 600;
                    justify-content: center;
                }
                .bc-action-btn.call-btn { color: #3b82f6; }
                .bc-action-btn.sms-btn { color: #10b981; }
                .bc-action-btn.profile-btn { color: #b8860b; }
                .bc-action-btn.create-btn { background: #2563eb; color: white; }
                .bc-action-btn:hover:not(:disabled) {
                    background: #f1f5f9;
                    transform: translateY(-2px);
                }
                .bc-action-btn.create-btn:hover {
                    background: #1d4ed8;
                }
                .bc-action-btn:disabled {
                    opacity: 0.35;
                    cursor: not-allowed;
                }

                .empty-state-card {
                    background: white;
                    border-radius: 20px;
                    padding: 50px;
                    border: 2px dashed #cbd5e1;
                    text-align: center;
                }
                .empty-icon {
                    font-size: 48px;
                    margin-bottom: 16px;
                    opacity: 0.6;
                }

                .slide-up-element { 
                    animation: slideUp 0.5s cubic-bezier(0.16, 1, 0.3, 1) forwards; 
                }
                @keyframes slideUp { 
                    from { opacity: 0; transform: translateY(20px); } 
                    to { opacity: 1; transform: translateY(0); } 
                }

                @media (max-width: 768px) {
                    .search-stats-row {
                        flex-direction: row;
                        flex-wrap: nowrap;
                        gap: 8px;
                        align-items: center;
                    }
                    .filter-container-modern {
                        flex: 1;
                        min-width: 0;
                    }
                    .search-wrapper-modern {
                        max-width: 100%;
                    }
                    .search-input-modern {
                        padding: 10px 30px 10px 38px;
                        font-size: 13px;
                    }
                    .search-icon-modern {
                        width: 16px;
                        height: 16px;
                        left: 12px;
                    }
                    .stats-container {
                        gap: 6px;
                        flex-shrink: 0;
                    }
                    .stat-card {
                        padding: 6px 12px;
                        gap: 6px;
                    }
                    .stat-icon {
                        font-size: 18px;
                    }
                    .stat-value {
                        font-size: 16px;
                    }
                    .stat-label {
                        font-size: 9px;
                    }
                    .bc-action-btn span { display: none; }
                    .bc-action-btn { padding: 8px; }
                    .bc-action-btn svg { margin: 0; }
                    .bc-card-footer { justify-content: center; gap: 8px; }
                    .profile-detail-container { max-width: 320px; }
                    .profile-avatar-bg { width: 90px; height: 90px; }
                    .profile-name { font-size: 18px; }
                    .profile-content { padding: 15px 16px 20px 16px; }
                    .btn-resp { font-size: 13px; padding: 12px; }
                }
                
                @media (max-width: 480px) {
                    .filter-container-modern {
                        flex: 1;
                        min-width: 0;
                    }
                    .bc-card-header { padding: 14px; }
                    .bc-avatar { width: 40px; height: 40px; }
                    .bc-booth-no { font-size: 15px; }
                    .bc-name { font-size: 15px; }
                    .stat-card { padding: 4px 10px; }
                    .stat-icon { font-size: 16px; }
                    .stat-value { font-size: 14px; }
                    .stat-label { font-size: 8px; }
                    .stats-container { gap: 4px; }
                    .search-input-modern { font-size: 12px; padding: 8px 24px 8px 32px; }
                    .search-icon-modern { width: 14px; height: 14px; left: 10px; }
                }
            `}</style>
        </div>
    );
};

export default BoothCaptain;